import { Pipe, PipeTransform } from "@angular/core";
import { TemplateRef } from "@angular/core";

@Pipe({ name: "columnTemplateRef" })
export class ColumnTemplateRefPipe implements PipeTransform {
   public transform(
      field: keyof any,
      columnTemplateMap: Map<string, TemplateRef<any>>
   ): TemplateRef<any> {
      return columnTemplateMap.get(field.toString());
   }
}
